/* src/app/components/pages/complete/complete.component.scss */
#complete {
  background-color: #EBEBEB;
  min-height: 385px;
  height: calc(100vh - 260px);
}
#complete .completeBox {
  margin-top: 60px;
}
@media only screen and (max-width: 992px) {
  #complete .completeBox {
    margin: 60px 30px 0px;
  }
}
@media only screen and (max-width: 600px) {
  #complete .completeBox {
    margin: 60px 15px 0px;
  }
}
#complete .completeBox ::ng-deep .mat-mdc-card {
  padding: 0px !important;
}
#complete .completeBox ::ng-deep .mat-mdc-card .mat-mdc-card-header .mat-mdc-card-header-text {
  margin: 0px;
}
#complete .completeBox ::ng-deep .mat-mdc-card .mat-mdc-card-title {
  margin-bottom: 0px;
}
#complete .completeBox .bg-color {
  background-color: var(--theme-deafult);
}
#complete .color-f-s-20 {
  color: rgba(0, 0, 0, 0.8705882353);
  font-size: 20px;
}
#complete .color-f-s-14 {
  color: rgba(0, 0, 0, 0.8705882353);
  font-size: 14px;
  font-weight: 700;
}
#complete .p-16 {
  padding: 16px 16px;
}
#complete .m-8 {
  margin: 8px;
}
#complete .text-underline {
  text-decoration: underline;
}
#complete .c-blue {
  color: blue !important;
}
/*# sourceMappingURL=complete.component.css.map */
